import { webAuth } from "$/lib/auth"

/**
 * For endpoints that carry no `@Auth` decorator on the API — currently the
 * password-reset pair, which is called by definition while logged out.
 */
export const { publicRequest } = webAuth
